import { postMypageNovelNovelIdFrontispiece } from "../../../api/v1/mypage/novel/[novel_id]/frontispiece/post"
import { MypageNovelNovelIdFrontispiecePostInputModel } from "../../../api/v1/mypage/novel/[novel_id]/frontispiece/PostInputModel"

export const fetchFrontispieceContainerId = (
  novelId: number,
): Promise<number> => {
  return postMypageNovelNovelIdFrontispiece(
    new MypageNovelNovelIdFrontispiecePostInputModel({ novelId }),
  ).then((v) => v.id)
}
